import template from 'text!./templates/typekey.html';

export default [function () {
    return {
        restrict: 'E',
        scope: { item: '&' },
        template: template
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-table/Typekey.js
// module id = 284
// module chunks = 0